import React, { useEffect } from 'react';
import QRCode from 'qrcode.react';
import PageFooter from '../../components/page-footer';
import PageHeader from '../../components/page-header';
import PageTools from '../../components/page-tools';
import GlobalImage from '../../components/imgComponent/index'
import { Spin } from 'antd'
import './index.less';

const Download = () => {
  /**
   * qcodeUrl 地址访问的页面，在staticwebpage/product/ucloud/download文件夹下
   * 存放在仓库：git@git.unipus.cn:frontend/staticwebpage.git里
   * 部署方法在download文件夹下的readme里
   */
  const qcodeUrl = 'https://app.unipus.cn/ucloud/apd_app.html';
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function downloadAPP(phone_type) { 
    window.open(qcodeUrl+'?phone_type='+phone_type, '_blank');
  }
  useEffect(() => { 
    if (isMobileDevice()) {
        window.location.href = qcodeUrl; 
    }
  },[])
  return (<>
  {
      isMobileDevice() ?
        <div className='loading'>
          <Spin />
        </div> :
        <div className="download">
         
          <div className="page">
          <GlobalImage className="color-bg" src="download-bg.png" alt="图片" />
            <div className="section_1">
              <div className="text_1">
                U校园AI版APP
                <br />
                下载尽情随意使用
              </div>
              <div className="block_2">
                <div className="btn" onClick={()=>downloadAPP(1)}>
                  <GlobalImage className="btn_img" src="android-2x.png" alt="图片" />
                  Android&nbsp;版
                </div>
                <div className="btn" onClick={()=>downloadAPP(2)}>
                  <GlobalImage className="btn_img" src="apple-2x.png" alt="图片" />
                  iOS&nbsp;版
                </div>
                <div className='qcrode-out'>
                  <div  className="qcrode">
                    <QRCode
                      size={84}
                      renderAs="canvas"
                      level="L"
                      value={qcodeUrl}
                    />
                  </div>
                </div>
              </div>
              <div className="text_2">手机扫描二维码免费下载APP</div>
            </div>
          </div>
          <PageHeader type="download" />
          <PageTools />
          <PageFooter />
        </div>
    }
  </>
  );
}

export default Download;
